export default {
  SET_CURRENT_SELECTED_STUDENT(state, currentStudent) {
    state.currentSelectedStudent = currentStudent
  },
  SET_USER_LIST(state, payload) {
    state.allUsers = payload
  },
  SET_STAFF_CHECK_IN_MODAL(state, payload) {
    state.staffCheckInModal = payload === undefined ? !state.staffCheckInModal : payload
  },
  SET_STAFF_CHECK_OUT_MODAL(state, payload) {
    state.staffCheckOutModal = payload === undefined ? !state.staffCheckOutModal : payload
  },
}
